export default {
  mediaModalShown: state => state.mediaModalShown,
  datePickerShortcut: state => state.datePickerShortcut,
  datePickerStartDate: state => state.datePickerStartDate,
  datePickerEndDate: state => state.datePickerEndDate,
  datePickerResolution: state => state.datePickerResolution,
  datePickerNumbersFilter: state => state.datePickerNumbersFilter,
  draggedOverKey: state => state.draggedOverKey,
  stepperDataStore: state => state.stepperDataStore,
};
